import { useState } from 'react';

import { Embed } from './Embed';
import { useStaff } from './session';

const TITLE = 'Leave Request Form';

/**
 * The forms app's leave request, carrying the signed-in staff member's name so the form
 * answers its own name question for them (`leave-request-is-an-embed` D2). Nothing is
 * asserted by sending it: the form resolves the name against its own staff roster and
 * ignores what it cannot place, and the field is free text to anyone who opens it.
 */
export function leaveRequestFormUrl(name: string): string {
  const url = new URL('https://forms.tutero.dev/leave-request');
  /* Set only when there is one: an empty parameter is a trailing `?` and a blank answer. */
  if (name.trim()) url.searchParams.set('name', name.trim());
  return url.toString();
}

/**
 * The leave form, drawn inside the admin the way the Vibes tools draw theirs
 * (`leave-request-is-an-embed` D1): the shell's own `Embed`, at the shell's own route,
 * reached from the account menu rather than the nav. No call of ours is made (A2).
 */
export default function LeaveRequestPage() {
  const staff = useStaff();
  /* Read once for the life of the page: an `src` that moves reloads the form mid-answer (D2). */
  const [src] = useState(() => leaveRequestFormUrl(staff.name));
  return <Embed title={TITLE} src={src} />;
}
